<template>
<!-- <Core :id="option.id" :type="type" @Update="(action,data)=>{$emit('Update',action,data);}" ref="Core"></Core> -->
<div>
	<Loading ref="Loading"></Loading>
	<div>{{$t('word1471',['标签'])}}</div>
	<transition-group tag="div" class="enableList mt05x bdSub boxR-light cb tra ml05x_E mt05x_E fL_E" :class="{pr3x:tagList&&tagList.length>0,pr1x:tagList==null||tagList.length==0}" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
		<button v-if="tagList&&tagList.length>0" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>
		<TagBox v-for="tag in tagList" :key="tag.id" :styleType="'tag'" :val="tag.name" :data="tag" @Remove="onRemove(tag.id)" ></TagBox>
		<button v-if="option.id || isBatch" :key="'add'" class="lh15 cMain" @click="addMode=true" type="button" onclick="statistic('A25','A2502')">{{'+'+getLanguageStr('word1788',['添加标签'])}}</button>
		<button v-else :key="'select'" class="lh15 cMain" @click="option.allTagShow=switchAllTag(!option.allTagShow)" type="button" onclick="statistic('A25','A2502')">{{'+'+getLanguageStr('cmd292',['选择标签'])}}</button>
	</transition-group>
	<transition name="effect-fadeRight-h4x" mode="out-in">
		<div v-if="addMode" class="h4x pt1x">
			<InputText class="w50pct dpIB" v-model="newTagName" name="newTagName" :max-length="50" :placeholder="getLanguageStr('phrase705','输入标签名称')" :clearBtn="true"></InputText>
			<button class="pl1x cSub hover-c-error" @click="addMode=false" type="button">{{$t('cmd85',['取消'])}}</button>
			<button class="pl1x cSub hover-c-main" :class="{disable:!newTagName||objTool(allTag,'findByKey',['name',newTagName])[0]>=0}" @click="newTag(newTagName)" type="button" onclick="statistic('A25','A2503')">{{$t('cmd12',['确定'])}}</button>
		</div>
	</transition>
	<div class="allTag" :class="{dpN:!option.allTagShow}"><!-- v-if="option.allTagShow"-->
		<div v-if="type==1" class="mt2x">{{getLanguageStr('word1977',['所有电站标签'])}}</div>
		<div class="h3x-min posR">
			<div v-if="allTag==null" class="mt05x disable">({{getLanguageStr('word256','暂无')}})</div>
			<div v-if="allTag&&allTag.length==0" class="mt05x disable">{{getLanguageStr('phrase85','加载中，请稍后....')}}</div>
			<div class="mt05x_E mr05x_E bdSub_E hover-main_E tra-fast_E">
				<button v-for="obj in allTag" :key="obj.id" :class="{'bgSub cSub peN':objTool(tagList,'findByKey',['id',obj.id])[1]}" @click="option.id?addTag([obj.id]):addToList(obj)" class="label" onclick="statistic('A25','A2504')">{{obj.name}}</button>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import TagBox from "@/components/common/ui/TagBox.vue";
import InputText from "@/components/common/ui/InputText.vue";
import Loading from "@/components/common/ui/Loading.vue";

import {getLanguageStr} from "@/util/language.js";
import * as lib from "@/util/lib.js";

import {getTags,apiAddTag,apiDeleteTag,apiUpdateTag, apiAddTagBatch} from "@/api/manage/tag.js";
export default{
	name:"TagManage",
	components:{TagBox,InputText,Loading},
	props:{
		type:{//1：电站、2：线索、3：客户、4：项目
			type:[String,Number],
			default:1
		},
		id:{//如果有id，即对象管理模式；没有id，即临时处理标签，输出选中列表
			type:[String,Number],
			default:null
		},
		list:{//生效的标签列表
			type:Array,
			default:()=>([])
		},
		maxAddNum:{//标签默认最大50
			type:Number,
			default:50
		},
		isBatch: {
			type: Boolean,
			default:false
		}
	},
	data(){
		return{
			option:{
				id:this.id,//对象id
				allTagShow:(this.id)? true:false//是否显示所有标签
			},
			tagList:this.list,//当前对象的标签列表
			allTag:[],//所有电站标签

			addMode:false,//是否在添加模式
			newTagName:""//新建标签的名称
		
		}
	},
	methods:{
		getLanguageStr,
		objTool:lib.objTool,
		transitionAction:lib.transitionAction,
		show:function(data){
			this.$nextTick(()=>{
				this.tagList=$.extend(true,[],this.list);
			});
			//this.batchAdd.tagIds = [];
			this.allTag=[];
			this.newTagName="";
			this.addMode=false;
			if(this.isBatch){ // 如果是批量处理的
				this.stationIds = data
			} else if($.type(data)=="array"){
				this.tagList=data;
			}
			else{
				this.option.id=data;
			}
			this.option.allTagShow=this.option.id || this.isBatch? true:false;

			if(this.option.id) this.$refs.Loading.show();
			setTimeout(()=>{
				if(this.option.id) this.getTag();
				this.getAllTag();
			},500);
		},
		hide:function(){
			// this.$refs.Window.hide();
		},
		// doPermissions:function(){
		// 	let pass=false;
		// 	switch(Number(this.type)){
		// 		case 1:
		// 			pass=lib.
		// 			break;
		// 	}
		// },
		switchAllTag:function(action){//切换显示所有标签
			if(action){//进行显示
				this.getAllTag();
				$(this.$el).find(".allTag").slideDown();
			}
			else{
				$(this.$el).find(".allTag").slideUp();
			}
			return action;
		},
		saveBatch(){ // 批量保存
			
			let ps = new Promise((r,e)=>{
				if(this.tagList.length ===0){
				this.$notify(getLanguageStr('manage358','标签不能为空'));
				e("标签不能为空")
				return
			}
				this.$refs.Loading.show();
				let batchAdd={
					'stationIds':[],
					'tagIds':[]
				}
				batchAdd.stationIds = this.stationIds
				batchAdd.tagIds=this.tagList.map(item=>{
					return item.id
				})
				apiAddTagBatch(batchAdd).then(success=>{
								//this.batchAdd.tagIds = []
								
								setTimeout(_=>{
									this.$refs.Loading.hide();
								},200)
								this.$emit("Update",this.tagList,"add");
							r('success');
							},error=>{
								e("error")
									this.$notify(error);
									this.$refs.Loading.hide();
									
								})
			})
			return ps;
			 
				
		},
		onRemove(tagIdList,endFn){//移除单个tag，data传入完整的tag对象
			if(this.isBatch){
				this.tagList = this.tagList.filter(data=>{
					if(data.id !== tagIdList){
						return data
					}
				})
				// this.batchAdd.tagIds = this.batchAdd.tagIds.filter(data=>{
				// 	if(data !== tagIdList){
				// 		return data
				// 	}
				// })
				return
			}
			if(this.option.id){
				this.$refs.Loading.show();
				apiDeleteTag(tagIdList,this.type,this.option.id).then(success=>{
					this.getTag(()=>{
						this.$emit("Update",this.tagList,"delete");
					});
					if(endFn) endFn();
				},error=>{
					this.$notify(error);
					this.$refs.Loading.hide();
				});
			}
			else{
				this.tagList.splice(lib.objTool(this.tagList,"findByKey",["id",tagIdList])[0],1);
				this.$emit("Update",this.tagList,"delete");
				// this.tagList[lib.objTool(this.tagList,"findByKey",["id",tag.id])[0]].name=null;
			}
			// let $this=this;
			// $.each(this.tagList,function(index){
			// 	if(this&&this.id===data.id){
			// 		$this.tagList.splice(index,1);
			// 	}
			// });
		},
		clear:function(){
			if(this.option.id){
				let deleteList=[];
				$.each(this.tagList,function(){
					deleteList.push(this.id);
				});
				this.onRemove(deleteList,()=>{
					// for(let obj of this.tagList){
					// 	obj.name="";
					// }
					this.tagList=[];
				});
			}
			else{
				this.tagList=[];
			}
		},
		getTag:function(endFn){//获取该电站的标签
			this.$refs.Loading.show();
			getTags(this.option.id,this.type).then(success=>{
				// trace(success,true)
				if(this.$refs.Loading) this.$refs.Loading.hide();
				// this.tagList=(success&&success.length)? success:null;
				this.tagList=success;
				if(endFn) endFn();
			},error=>{
				this.$notify(error);
				if(this.$refs.Loading) this.$refs.Loading.hide();
			});
		},
		getAllTag:function(){//获取所有的电站标签
			// this.$refs.LoadingAllTag.show();
			this.allTag=[];
			getTags({
				objectType:this.type,
				"order.direction":"DESC",
				"order.property":"id",
				page:1,
				size:9999
			}).then(success=>{
				// trace(success,true)
				// this.$refs.LoadingAllTag.hide();
				this.allTag=success.data&&success.data.length>0? success.data:null;//
				// if(success.total==0){
				// 	this.allTag=null;
				// 	// this.$set(this,"allTag",null);
				// }
			},error=>{
				this.$notify(error);
			});
		},
		newTag:function(text){//新建标签
			// if(lib.doPermissions("D/B/A2")){
				this.$refs.Loading.show();
				apiAddTag(text,[this.type]).then(success=>{
					// trace(success,true)
					// this.tagList.push(success);
					if(this.isBatch){
						//this.batchAdd.tagIds.push(success)
						this.tagList.push({
							id:success,
							name:text
						})
						this.$refs.Loading.hide();
					}else{
						this.addTag([success]);
					}
					
					this.getAllTag()
					this.newTagName="";
				},error=>{
					this.$notify(error);
					this.$refs.Loading.hide();
				});
			// }
			// else this.$notify(getLanguageStr('phrase558','没有权限'));
		},
		addTag:function(idList){//给对象添加标签
		
			let pass=false;
			let $this=this;
			switch(Number(this.type)){
				case 1:/*电站*/pass=lib.doPermissions("A/B/A17");break;
			}
			
			// if(pass){
				this.$refs.Loading.show();
				apiAddTag(idList,[this.type],"",this.option.id,this.type).then(success=>{
					// trace(success,true)
					// this.tagList.splice(0,0,...idList);
					// $.each(idList,function(){
					// 	$this.tagList.push(lib.objTool($this.allTag,"findByKey",["id",this])[1]);
					// })
					this.getTag(()=>{
						this.$emit("Update",this.tagList,"add");
					});
				},error=>{
					this.$notify(error);
					this.$refs.Loading.hide();
				});
			// }
			// else this.$notify(getLanguageStr('phrase558','没有权限'));
		},
		// updateTag:function(){//保存动作
		// 	this.$refs.Window.loadStatusAction(true);

		// 	let idList=[];
		// 	$.each(this.tagList,function(index){
		// 		idList.push(this.id);
		// 	});
		// 	apiUpdateTag(idList,this.id,this.type).then(success=>{
		// 		trace(success,true)
		// 		this.$refs.Window.loadStatusAction(false);
		// 		this.hide();
		// 	},error=>{
		// 		this.$notify(error);
		// 	});
		// },
		addToList:function(tag){//加入tag列表
			// let isNew=true;
			// $.each(this.tagList,function(){
			// 	if(this.id==tag.id){
			// 		isNew=false;
			// 	}
			// });
			if(this.isBatch){
				this.tagList.push(tag)
				//this.batchAdd.tagIds.push(tag.id)
				
				return
			}
			if(this.tagList.length >= this.maxAddNum){
				this.$notify(i18n.t('fill3rd130', [getLanguageStr('word1471','标签'),this.maxAddNum, '标签数量已超出上限，上限n个']))
				// this.$notify(i18n.t('fill3rd130',[this.maxAddNum,'标签数量已超出上限，上限n个']));
				return;
			}
			if(lib.objTool(this.tagList,"findByKey",["id",tag.id])[0]<0){
				this.tagList.push(tag);
				this.$emit("Update",this.tagList,"add");
			}
		}
	},
	created(){},
	mounted(){
		if(!this.option.id) this.$refs.Loading.hide();//没有指明对象，即不用默认显示加载效果
	}
}
</script>
<style lang="scss" scoped>
.enableList{padding:{bottom:.5em;};position:relative;
	.clearTag{position:absolute;top:0;right:.5em;}
}
</style>


// WEBPACK FOOTER //
// src/components/common/tagManage/Core.vue